import {
  postCall,
  getCall,
  HeadersInterface,
  BodyParamsInterface,
} from "./api";

const BASE_URL = "v1/";

export const getAllTeams = async () => {
  let url = BASE_URL + "teams";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getTeamsByCompetitionAndSeason = async (
  competition_id: string,
  season_id: string
) => {
  let url =
    BASE_URL +
    "shirtmodels/teams?competition_id=" +
    competition_id +
    "&season_id=" +
    season_id;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getTeamsByCompetitionWithCount = async (
  competition_id: string
) => {
  let url =
    BASE_URL + "shirtmodels/teams/count?competition_id=" + competition_id;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getTeamsByNationalTeamValue = async (national_team: boolean) => {
  const param = national_team ? "1" : "0";
  let url = BASE_URL + "shirtmodels/teams/national?national_team=" + param;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};
export const getTeamsByNationalTeamValueWithCount = async (
  national_team: boolean
) => {
  const param = national_team ? "1" : "0";
  let url =
    BASE_URL + "shirtmodels/teams/national/count?national_team=" + param;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllSeasons = async () => {
  let url = BASE_URL + "seasons";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getSeasonsByCompetition = async (competition_id: string) => {
  let url = BASE_URL + "seasons";
  let headers: HeadersInterface | undefined;

  let response = await getCall(
    url,
    headers,
    `competition_id=${competition_id}`
  );

  return response.data;
};

export const getAllCompetitions = async () => {
  let url = BASE_URL + "competitions";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllPlayers = async () => {
  let url = BASE_URL + "players";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllPlayersByTeamAndSeasonAndCompetition = async (
  competition_id: string,
  season_id: string,
  team_id: string
) => {
  let url =
    BASE_URL +
    "shirtmodels/players?competition_id=" +
    competition_id +
    "&season_id=" +
    season_id +
    "&team_id=" +
    team_id;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllShirtTypes = async () => {
  let url = BASE_URL + "types";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllVariants = async () => {
  let url = BASE_URL + "variants";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllBrands = async () => {
  let url = BASE_URL + "brands";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllConditions = async () => {
  let url = BASE_URL + "conditions";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getAllProperties = async () => {
  let url = BASE_URL + "properties";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const getNumbersByPlayerInfo = async (
  competitionId: string,
  seasonId: string,
  teamId: string,
  playerId: string
) => {
  let url = BASE_URL + "shirtmodels/players/numbers";
  let headers: HeadersInterface | undefined;
  const params =
    "competition_id=" +
    competitionId +
    "&season_id=" +
    seasonId +
    "&team_id=" +
    teamId +
    "&player_id=" +
    playerId;

  let response = await getCall(url, headers, params);

  return response.data;
};

export const getBrandByTeamAndSeason = async (
  competitionId: string,
  seasonId: string,
  teamId: string,
  shirtTypeId: number
) => {
  let url = BASE_URL + "shirtmodels/team/season/competition/type/brands";
  let headers: HeadersInterface | undefined;
  const params =
    "competition_id=" +
    competitionId +
    "&season_id=" +
    seasonId +
    "&team_id=" +
    teamId +
    "&shirt_type_id=" +
    shirtTypeId;

  let response = await getCall(url, headers, params);

  return response.data;
};
